<!-- 组件说明 -->
<template>
  <div class="order">
    <div style="margin-top:0.8rem;">
      <van-divider :style="{ color: '#333', padding: '0 16px' }">{{$t('order.goods_info')}}</van-divider>
      <div class="card-goods__item" v-for="item in orderGoods" :key="item.id" :name="item">
        <van-card
          :title="item.prodName"
          :desc="item.desc"
          :num="item.num"
          :price="formatPrice(item.price)"
          :thumb="item.pic"
        />
      </div>
    </div>
    <div style="margin-top:0.8rem;">
      <van-divider :style="{ color: '#333', padding: '0 16px' }">{{$t('order.pay_way')}}</van-divider>
      <div>送货地点</div>
      <van-cell @click="locationPop = true" title="单元格" is-link />
      <div>送货方式</div>
      <van-cell @click="diliverWayPop = true" title="单元格" is-link />
      <div>付款付款方式付款方式付款方式付款方式付款方式付款方式付款方式付款方式付款方式付款方式付款方式付款方式方式</div>
      <div>付款方式</div>
      <van-cell @click="payWapPop = true" title="单元格" is-link />
    </div>
    <van-popup v-model="locationPop" class="pop">
      <van-radio-group v-model="radio">
        <van-radio class="radio_item" name="1">台湾</van-radio>
      </van-radio-group>
    </van-popup>
    <van-popup v-model="diliverWayPop" class="pop">
      <van-radio-group v-model="radio">
        <van-radio class="radio_item" name="1">单选框 1</van-radio>
        <van-radio class="radio_item" name="2">单选框 2</van-radio>
      </van-radio-group>
    </van-popup>
    <van-popup v-model="payWapPop" class="pop">
      <van-radio-group v-model="radio">
        <van-radio class="radio_item" name="1">单选框 1</van-radio>
        <van-radio class="radio_item" name="2">单选框 2</van-radio>
      </van-radio-group>
    </van-popup>
    <div style="margin-top:0.8rem;">
      <van-divider :style="{ color: '#333', padding: '0 16px' }">{{$t('order.pick_info')}}</van-divider>
      <van-cell-group>
        <van-field
          v-model="name"
          required
          clearable
          :label="$t('order.name_name')"
          :error="errorInfo.name"
          @focus="foucs('name')"
          :placeholder="$t('order.name')"
        />
        <van-field
          v-model="tel"
          required
          clearable
          :label="$t('order.phone_name')"
          @focus="foucs('tel')"
          :error="errorInfo.tel"
          :placeholder="$t('order.phone')"
        />

        <van-field
          v-model="addressDetail"
          required
          clearable
          :label="$t('order.address_name')"
          @focus="foucs('areaCode')"
          :error="errorInfo.addressDetail"
          :placeholder="$t('order.address')"
        />
      </van-cell-group>
    </div>

    <van-submit-bar :price="totalPrice" :button-text="$t('order.offer_order')" @submit="onSubmit" />
    <van-popup v-model="showPicker" position="bottom">
      <van-area
        :area-list="areaList"
        :columns-placeholder="columnsPlaceholder"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import { Toast } from 'vant';
import AreaList from '@/utils/provice';
import { mapMutations, mapState } from 'vuex';
export default {
  components: {},
  data() {
    return {
      radio: '1',
      locationPop: false,
      diliverWayPop: false,
      payWapPop: false,
      pay: '1',
      name: '',
      tel: '',
      addressDetail: '',
      areaCode: '',
      areaList: AreaList,
      columnsPlaceholder: [this.$t('tips.chose'), this.$t('tips.chose'), this.$t('tips.chose')],
      showPicker: false,
      errorInfo: {
        tel: false,
        name: false,
        postalCode: false,
        addressDetail: false,
      },
    };
  },
  computed: {
    orderGoods: {
      get() {
        return this.$store.state.goods.orderGoods;
      },
      set(val) {},
    },
    totalPrice() {
      return this.orderGoods.reduce((total, item) => total + item.price * item.num, 0);
    },
  },
  methods: {
    ...mapMutations('goods', {
      removeShopCardGoods: 'removeShopCardGoods',
    }),
    formatPrice(price) {
      return (price / 100).toFixed(2);
    },

    onConfirm(e) {
      this.areaCode = e.reduce((add, item) => add + (item ? item.name : '') + ' ', '');
      if (!this.areaCode) {
        Toast(this.$t('tips.area_not_empty'));
      } else {
        this.showPicker = false;
      }
    },
    onSubmit(e) {
      var items = ['name', 'tel', 'areaCode', 'addressDetail'];
      var isValid = items.every((item) => {
        var msg = this.getErrorMessage(item);
        if (msg) {
          this.errorInfo[item] = true;
          Toast(msg);
        }
        return !msg;
      });
      if (!isValid) {
        return;
      }
      let ids = [];
      this.orderGoods.forEach((element) => {
        ids.push(element.id);
      });
      if (this.from === 'Cart') {
        this.removeShopCardGoods(ids);
      }
      this.$router.replace('success');
    },
    payOnLine(e) {
      Toast(this.$t('tips.un_pay_on_line'));
    },

    foucs(key) {
      // console.log('===key=', key);
      this.errorInfo[key] = false;
    },
    isMobile(value) {
      value = value.replace(/[^-|\d]/g, '');
      return /^((\+86)|(86))?(1)\d{10}$/.test(value) || /^0[0-9-]{10,13}$/.test(value);
    },

    getErrorMessage(key) {
      // console.log('====', this);
      var value = String(this._data[key] || '').trim();
      switch (key) {
        case 'name':
          return value ? '' : this.$t('tips.name_not_empty');

        case 'tel':
          return this.isMobile(value) ? '' : this.$t('tips.phone_not_empty');

        case 'areaCode':
          return value ? '' : this.$t('tips.area_not_empty');

        case 'addressDetail':
          return value ? '' : this.$t('tips.address_not_empty');
      }
    },
  },
  created() {
    //生命周期 - 创建完成
  },

  beforeRouteEnter(to, from, next) {
    // 在渲染该组件的对应路由被 confirm 前调用
    // 不！能！获取组件实例 `this`
    // 因为当守卫执行前，组件实例还没被创建
    let fromPage = from.name;
    if (fromPage == 'Cart' || fromPage == 'GoodsDetail') {
      next((vm) => {
        vm.from = fromPage;
      });
    } else {
      next('list');
    }
  },
  destroyed() {
    //生命周期 - 销毁完成
  },
};
</script>

<style lang='scss' scoped>
.order {
  padding-bottom: 50px;
}
.goods_detail {
  margin-top: 0.8rem;
  padding: 0 0.32rem;
}
.pop {
  width: 10rem;
  border-radius: 0.12rem;
  padding: 0.4rem 0.8rem 1.2rem 0.8rem;
  .radio_item {
    margin-top: 0.8rem;
  }
}
.address {
  margin-top: 0.8rem;
  padding: 0 0.32rem;
}
.border {
  padding: 0 0.32rem;
  border: 0.04rem #fafafa solid;
}
</style>
<style lang='scss' >
</style>


// WEBPACK FOOTER //
// src/pages/Order.vue